import { motion } from "framer-motion";
import { FaYoutube, FaInstagram, FaTiktok, FaLinkedinIn } from "react-icons/fa6";
import { scrollToId } from "@/hooks/useLenis";
import { PROFILE, SOCIALS, IMAGES } from "@/data/content";

const ICONS = { SiYoutube: FaYoutube, SiInstagram: FaInstagram, SiTiktok: FaTiktok, SiLinkedin: FaLinkedinIn };

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-obsidian border-t-2 border-blue/30 px-5 md:px-10 pt-16 pb-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-md">
            <motion.button
              onClick={() => scrollToId("top")}
              whileHover={{ rotate: -8, scale: 1.05 }}
              className="flex items-center gap-4"
            >
              <img src={IMAGES.face} alt="Justin Leusner" className="h-14 w-14 rounded-full object-cover object-center bg-blue border-2 border-yellow" />
              <span className="font-anton uppercase text-2xl text-white">{PROFILE.firstName} {PROFILE.lastName}</span>
            </motion.button>
            <a
              href={`mailto:${PROFILE.email}`}
              data-testid="footer-email"
              className="inline-block font-outfit font-bold text-yellow mt-5 hover:text-blue transition-colors"
            >
              {PROFILE.email}
            </a>
          </div>

          <div className="flex flex-col gap-4">
            <span className="font-outfit text-xs uppercase tracking-widest text-white/40">Come Say Hi</span>
            <div className="flex flex-wrap gap-3">
              {SOCIALS.map((s) => {
                const Icon = ICONS[s.icon];
                return (
                  <motion.a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`social-${s.name}`}
                    whileHover={{ scale: 1.12, rotate: -6 }}
                    whileTap={{ scale: 0.9 }}
                    className="h-12 w-12 rounded-full bg-white/10 hover:bg-blue hover:text-obsidian text-white flex items-center justify-center transition-colors duration-200"
                    aria-label={s.name}
                  >
                    {Icon && <Icon size={20} />}
                  </motion.a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3">
          <span className="font-outfit text-xs text-white/40 uppercase tracking-wider">
            © {new Date().getFullYear()} {PROFILE.name}. All rights reserved.
          </span>
          <span className="font-outfit text-xs text-white/40 uppercase tracking-wider">
            Made with a love of the game ✦
          </span>
        </div>
      </div>
    </footer>
  );
};
